/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface Authentication
 */
export interface Authentication {
    /**
     * 
     * @type {PersonHandle}
     * @memberof Authentication
     */
    handle: PersonHandle;
    /**
     * RFC3339 timestamp
     * @type {Date}
     * @memberof Authentication
     */
    timestamp: Date;
    /**
     * 
     * @type {FactorMethod}
     * @memberof Authentication
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the Authentication interface.
 */
export function instanceOfAuthentication(value: object): value is Authentication {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function AuthenticationFromJSON(json: any): Authentication {
    return AuthenticationFromJSONTyped(json, false);
}

export function AuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Authentication {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': PersonHandleFromJSON(json['handle']),
        'timestamp': (new Date(json['timestamp'])),
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function AuthenticationToJSON(json: any): Authentication {
    return AuthenticationToJSONTyped(json, false);
}

export function AuthenticationToJSONTyped(value?: Authentication | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': PersonHandleToJSON(value['handle']),
        'timestamp': value['timestamp'].toISOString(),
        'method': FactorMethodToJSON(value['method']),
    };
}

